import { Injectable } from '@angular/core';
import { OutputAdapterService } from '@core/modules/api/services/output-adapter/output-adapter.service';

@Injectable({
  providedIn: 'root'
})
export class OutputAdapterCustomService extends OutputAdapterService {
  constructor() {
    super();
  }
}
